import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import type { Dispatch, SetStateAction } from 'react';
import { useEffect, useState } from 'react';

import { useAppSelector } from 'shared/lib/redux';

export const useUpdateStateBySelector = <T>(
  selector: (state: Store) => T,
  equalityFn?: (left: T, right: T) => boolean,
): [T, Dispatch<SetStateAction<T>>] => {
  const data = useAppSelector(selector, equalityFn);
  const [state, setState] = useState<T>(cloneDeep(data));

  useEffect(() => {
    // Проверяем что данные из стора точно обновились и не равны данным в стейте, чтобы не ререндерить лишний раз
    if (!isEqual(state, data)) {
      setState(cloneDeep(data));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return [state, setState];
};
